import React from "react";
import LoginSignup from "../components/LoginSignup";

const LoginPage = () => {
  return (
    <>
      <LoginSignup />
    </>
  );
};

export default LoginPage;
